import indicators from "./software-indicators.json";

export const SOFTWARE_CORE_REQUIRED_INDICATOR_IDS = [1, 13, 14, 17];
export default indicators;
